import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DBIconService, DBModalService} from '@db/db-core';
import { getAppThemeName } from './core/functions/common.function';
import { SessionTimerService } from './shared/services/session-timer.service';
import { formatS } from './shared/utils/time-utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DbHeaderComponent } from './shared/components/header/header-db/header-db.component';
import { PbHeaderComponent } from './shared/components/header/header-pb/header-pb.component';
import { NbHeaderComponent } from './shared/components/header/header-nb/header-nb.component';
import { DBFooterComponent } from '@db/db-components';
import { DBModalModule, DBIconModule } from '@db/db-core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    DbHeaderComponent,
    PbHeaderComponent,
    NbHeaderComponent,
    DBFooterComponent,
    DBModalModule,
    DBIconModule
  ]
})
export class AppComponent implements OnInit {
  @ViewChild('modalTemplate', {
    read: TemplateRef,
    static: true
  })
  public modalTemplateRef!: TemplateRef<any>;
  public title = 'permission-dashboard-ui';
  public themeName?: string;
  public timeLeft = 0;
  public formatSeconds = formatS;
  private isModalOpen = false;
    favIcon: HTMLLinkElement | null;


  constructor(
    public sessionTimer: SessionTimerService,
    private modalService: DBModalService,
    private translate: TranslateService
  ) {
      this.favIcon = document.querySelector('#favIcon');
      if (this.favIcon !== null) {
          this.favIcon.href = `./assets/favicon-${getAppThemeName()}.${getAppThemeName() === 'pb' ? 'svg' : 'ico'}`;
      }

    this.themeName = getAppThemeName();
    const LANGUAGES: Array<string> = this.themeName === 'db' ? ['en', 'de'] : ['de'];
    const DEFAULT_LANG = this.themeName === 'db' ? 'en' : 'de';
    this.translate.addLangs(LANGUAGES);
    this.translate.setDefaultLang(DEFAULT_LANG);

    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang && LANGUAGES.includes(browserLang) ? browserLang : 'de');
  }

  ngOnInit(): void {
      if (this.favIcon !== null) {
          this.favIcon.href = `./assets/favicon-${getAppThemeName()}.${getAppThemeName() === 'pb' ? 'svg' : 'ico'}`;
      }
    this.sessionTimer.graceWarn$.subscribe(show => {
      show ? this.openModal() : this.closeModal();
      this.isModalOpen = show;
    });
  }

  private openModal(): void {
    this.modalService.close(); // first close any other modals that might be open; there cannot be 2 modals open at the same time
    // without setTimout the modal service combines the templates
    setTimeout(() => this.modalService.openWithTemplate(this.modalTemplateRef, { closeOnBackdropClickOrEscKey: false }), 1000);
  }

  private closeModal(): void {
    if (this.isModalOpen) { // otherwise closes all modals that might be open at every mouse move
      this.modalService.close();
    }
  }

  protected readonly getAppThemeName = getAppThemeName;
}
